import React from 'react';
import { Navigate } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';

/** Alias kept for old links; same as /teacher-dashboard. */
const TeacherToolsRoute = () => (
  <ProtectedRoute requiresAuth={true}>
    <Navigate to="/teacher-dashboard" replace />
  </ProtectedRoute>
);

export default TeacherToolsRoute;
